import { ensureCameraPermission, getBrowserCameraSettingsMessage, openBrowserCameraSettings } from '@/utils/camera-permission'

/**
 * Mixin compartilhado entre Selfie.vue e SelfieFace.vue.
 * Centraliza a lógica de verificação e feedback de permissão de câmera.
 *
 * Requisitos do componente que usa este mixin:
 *   - data: selfieActive, startCapture, isInitializingCapture
 *   - methods: openTerminalAlert, retryProcess, resetCaptureState
 *
 * Opcional (Selfie.vue):
 *   - data: isSubmittingSelfie
 */
export const cameraPermissionMixin = {
  methods: {
    openCameraBlockedAlert() {
      this.selfieActive = false
      this.startCapture = false
      this.isInitializingCapture = false

      if ('isSubmittingSelfie' in this) {
        this.isSubmittingSelfie = false
      }

      this.alert = {
        show: true,
        type: 'danger',
        title: 'Câmera bloqueada',
        message: 'O acesso à câmera está bloqueado neste navegador. Desbloqueie a câmera nas configurações do navegador para continuar a validação.',
        action: this.openCameraSettings,
        textButton: 'Abrir configurações do navegador'
      }
    },

    async validateCameraPermission({ requestIfNeeded = false } = {}) {
      const permission = await ensureCameraPermission({ requestIfNeeded })

      if (permission.allowed || permission.state === 'prompt') {
        return true
      }

      if (permission.unsupported) {
        this.openTerminalAlert(
          'Seu navegador não oferece suporte ao acesso à câmera. Atualize o navegador ou utilize outro navegador compatível.',
          this.retryProcess,
          'Tentar novamente'
        )
        return false
      }

      if (!requestIfNeeded && !permission.blocked) {
        return true
      }

      this.openCameraBlockedAlert()
      return false
    },

    openCameraSettings() {
      openBrowserCameraSettings()

      this.$buefy.toast.open({
        duration: 7000,
        message: getBrowserCameraSettingsMessage(),
        position: 'is-top',
        type: 'is-warning'
      })

      this.resetCaptureState()
    }
  }
}
